import { render, staticRenderFns } from "./project-members.page.vue?vue&type=template&id=b65d1db2&scoped=true&"
import script from "./project-members.page.vue?vue&type=script&lang=js&"
export * from "./project-members.page.vue?vue&type=script&lang=js&"
import style0 from "./project-members.page.vue?vue&type=style&index=0&id=b65d1db2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b65d1db2",
  null
  
)

export default component.exports